module.exports = __webpack_public_path__ + "static/media/BGP-CHJSeries.83066bcf.pdf";